import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "actionProps"];
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import classnames from 'classnames';
import DialogActions from '@mui/material/DialogActions';
import { EmbersButton } from '../button/button';
import { EmbersLink } from '../link/link';
import { createDialogFooterTheme, FOOTER_ROOT_PREFIX } from './modalStyles';

/** primary: save button; secondary: cancel button; tertiary: link button */

export var EmbersModalFooter = function EmbersModalFooter(_ref) {
  var className = _ref.className,
    actionProps = _ref.actionProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = actionProps || {},
    tertiary = _ref2.tertiary,
    secondary = _ref2.secondary,
    primary = _ref2.primary;
  var handleTertiaryKeyDown = function handleTertiaryKeyDown(e) {
    if (e.key === ' ' || e.key === 'Enter') {
      var _tertiary$onClick;
      e.stopPropagation();
      tertiary === null || tertiary === void 0 || (_tertiary$onClick = tertiary.onClick) === null || _tertiary$onClick === void 0 || _tertiary$onClick.call(tertiary, e);
    }
  };
  var renderButtons = function renderButtons() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !!(tertiary !== null && tertiary !== void 0 && tertiary.label) && !tertiary.hidden &&
    /*#__PURE__*/
    // per UX, all tertiary buttons in modals will actually be links
    // because otherwise the modals were too "button-heavy"
    React.createElement(EmbersLink, _extends({
      mode: "light",
      onKeyUp: handleTertiaryKeyDown
    }, tertiary), tertiary.label), /*#__PURE__*/React.createElement("div", {
      className: "".concat(FOOTER_ROOT_PREFIX, "-buttons")
    }, !!secondary && !secondary.hidden && /*#__PURE__*/React.createElement(EmbersButton, _extends({
      drawingStyle: "outlined"
    }, secondary), secondary.label), !!primary && !primary.hidden && /*#__PURE__*/React.createElement(EmbersButton, primary, primary.label)));
  };
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: createDialogFooterTheme
  }, /*#__PURE__*/React.createElement(DialogActions, _extends({
    className: classnames("".concat(FOOTER_ROOT_PREFIX, "-root"), _defineProperty({}, "".concat(FOOTER_ROOT_PREFIX, "-tertiary-wrap"), tertiary === null || tertiary === void 0 ? void 0 : tertiary.label))
  }, props), renderButtons()));
};